import React from "react";
import { Link } from "react-router-dom";

import classes from "./CallToAction.module.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Button from "@mui/material/Button";
import WazeSVGIcon from "../Components/WazeSVGIcon";
// import GetClientDetailsForm from "./GetClientDetailsForm";

export default function CallToAction() {
  return (
    <section className={classes.sectionCTA}>
      <div className={classes.ctaOptions}>
        <h3>לביצוע הזמנה באתר:</h3>

        <Link to="/orders" className={classes.callToActionLink}>
          <Button
            dir="rtl"
            variant="contained"
            startIcon={<ShoppingCartIcon />}
            size="large"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "24rem",
              fontSize: "1.5rem",
              backgroundColor: "#4caf50",
              ":hover": { backgroundColor: "#388e3c" },
            }}
          >
            בצע הזמנה באתר
          </Button>
        </Link>

        <h3 style={{ marginTop: "2rem" }}>או התקשרו ישירות:</h3>
        <h3 className={classes.phoneColor}>
          <strong>050-5582265</strong>
        </h3>
        <a href="tel:0505582265" className={classes.callToActionLink}>
          <Button
            dir="rtl"
            variant="contained"
            startIcon={<PhoneAndroidIcon />}
            size="large"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "24rem",
              fontSize: "1.5rem",
            }}
          >
            לחיוג מהיר לחץ כאן
          </Button>
        </a>
        <a
          href="https://wa.me/+972505582265"
          className={classes.callToActionLink}
        >
          <Button
            dir="rtl"
            variant="contained"
            startIcon={<WhatsAppIcon />}
            color="success"
            size="large"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "24rem",
              fontSize: "1.5rem",
            }}
          >
            לשליחת הודעה לחץ כאן
          </Button>
        </a>
        <a
          href="waze://?ll=32.020877,34.800891&navigate=yes"
          className={classes.callToActionLink}
        >
          <Button
            dir="rtl"
            variant="contained"
            startIcon={<WazeSVGIcon />}
            size="large"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "24rem",
              fontSize: "1.5rem",

              backgroundColor: "#05c8f7",
              ":hover": { backgroundColor: "#056a82" },
            }}
          >
            להגיע עם waze
          </Button>
        </a>
        <br />
        {/* <GetClientDetailsForm /> */}
      </div>
    </section>
  );
}
